import React from 'react';
import { connect } from 'react-redux';
import { AdminAwardBuyerModal } from './index';
import FinalizeSaleModal from '../../TransactionsList/components/FinalizeSaleModal';
import { useGetBuyerFeesQuery } from '../../../../services/api/buyer-fees';
import { useGetAuctionByIdQuery } from '../../../../services/api/auctions-list';
import { useParams } from 'react-router-dom';

const Modals = ({ vehicle }) => {
  const { id: auctionId } = useParams();
  // const { data: auctionData } = useGetAuctionByIdQuery(auctionId, { skip: !auctionId });
  const auctionData = vehicle?.auction
  const { data: fees = [] } = useGetBuyerFeesQuery(auctionData?.type, { skip: !auctionData });
  if (vehicle) {
    const highestBid = vehicle.highest_bid;
    return (
      <>
        <AdminAwardBuyerModal
          initialValues={{ vehicle_id: vehicle.id }}
          vehicle={vehicle}
          fees={fees}
          highestBid={highestBid?.amount ? highestBid : null}
        />
        <FinalizeSaleModal vehicle={vehicle} form="finalizeSaleForm" />
      </>
    );
  }
  return <FinalizeSaleModal vehicle={vehicle} form="finalizeSaleForm" />;
};

const mapStateToProps = state => ({
  vehicle: state.auctions.auctionVehiclesModal
});

export default connect(mapStateToProps)(Modals);
